export default __webpack_public_path__ + "static/media/center-bg.187ad7de.png";